import { InputSelect } from './select';
export type { InputSelectProps } from './select';
export default InputSelect;
